import { Checkbox } from 'material-ui';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

export default function BasicCheckBox({ 
    label = '',
    checked,
    style = {},
    labelStyle = {},
    handleChange,
    iconStyle = {},
}) {    
    const onCheck = () => {
        handleChange(!checked);
    };
    
    return (
        <Checkbox 
            name={uuidv4()}
            checked={checked}
            onCheck={onCheck}
            label={label}
            style={{ ...style }}
            labelStyle={{ ...labelStyle }}
            iconStyle={{ width: '20px', marginLeft: '-1px', ...iconStyle }}
        />
    );
}



// WEBPACK FOOTER //
// ./app/components/TcIndex/Basic/BasicCheckBox.jsx